import React, { useState, useEffect, useRef } from 'react';

const AutoCompleteInput = ({ label, value, onChange, options = [], name, placeholder }) => {
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef();

  // Chiude il menu se clicchi fuori
  useEffect(() => {
    const handleClickOutside = e => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Filtra opzioni
  const handleInputChange = e => {
    const inputVal = e.target.value;
    onChange(inputVal);

    if (inputVal.length === 0) {
      setIsOpen(false);
      setFilteredOptions([]);
      return;
    }

    const filtered = options.filter(opt => opt.toLowerCase().includes(inputVal.toLowerCase()));

    setFilteredOptions(filtered.slice(0, 10)); // Limita a 10 suggerimenti
    setIsOpen(true);
  };

  const handleSelect = option => {
    onChange(option);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={wrapperRef}>
      <label htmlFor={name} className="mb-1 block text-sm font-medium text-gray-900">
        {label}
      </label>
      <input
        id={name}
        name={name}
        type="text"
        autoComplete="off"
        value={value}
        required
        onChange={handleInputChange}
        placeholder={placeholder}
        className="w-full rounded-md border border-gray-300 px-4 py-2 text-gray-800 shadow-sm focus:border-primary focus:ring-primary"
      />
      {isOpen && filteredOptions.length > 0 && (
        <ul className="absolute z-10 mt-1 max-h-60 w-full overflow-y-auto rounded-md border border-gray-300 bg-white shadow-lg">
          {filteredOptions.map((option, idx) => (
            <li key={idx + 1}>
              <button
                type="button"
                className="w-full cursor-pointer px-4 py-2 text-left text-gray-800 hover:bg-primary"
                onClick={() => handleSelect(option)}
              >
                {option}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutoCompleteInput;
